@if(campaign) {
  <div class="campaign" fixedWidth ref="campaign-sidebar">
    <h2>Redigera kampanj</h2>
    
    @if(show.selectContainer) {
      <div class="account__card account__card--margin--right account__card--no--animate">
        <div class="text-center">
          <h2>Vad vill du göra?</h2>
          <button class="button" (click)="navigateTo('extendCampaign')">Förlänga kampanj</button>
          @if(campaign.status === 'ongoing') { 
            <button class="button" (click)="navigateTo('updateCampaignBudget')">Utöka kampanjbudget</button>
            <button class="button" (click)="navigateTo('boostGoals')">Öka eller minska mål</button>
            @if(hasVideoCreatives) { 
              <button class="button" (click)="navigateTo('addCreative')">Lägga till film</button> 
            }
            <button class="button" (click)="navigateTo('updateCampaignName')">Ändra namn</button>
          }
        </div>
        <div class="clearfix">
          <button class="link primary-1 float-end" [routerLink]="['/dashboard', campaign.id]">Avbryt</button>
        </div>
      </div>
    }
    
    @if(show.extendCampaign) {
      <div class="margin-right--1x">
        <extend-campaign [campaign]="campaign" (campaignUpdated)="campaignExtended($event)" (onAbort)="navigateTo('selectContainer')"></extend-campaign>
      </div>
    }
  
    @if(show.boostGoals) {
      <div class="margin-right--1x">
        <edit-goals
          [campaign]="campaign"
          (onAbort)="navigateTo('selectContainer')"
          (onSuccess)="loadCampaign(); navigateTo('selectContainer');"
          (campaignNeedsReload)="loadCampaign()"
        ></edit-goals>
      </div>
    }
  
    @if(show.addCreative) {
      <div class="account__card account__card--margin--right account__card--no--animate">
        <add-creative-to-ongoing-campaign class="margin--none" (onAbort)="loadCampaign(); navigateTo('selectContainer')" [campaign]="campaign"></add-creative-to-ongoing-campaign>
      </div>
    }
  
    @if(show.updateCampaignName) {
      <div class="account__card account__card--margin--right account__card--no--animate">
        <update-ongoing-campaign-name
          class="margin--none"
          (onAbort)="navigateTo('selectContainer')"
          (onSuccess)="loadCampaign(); navigateTo('selectContainer');"
          [campaign]="campaign">
        </update-ongoing-campaign-name>
      </div>
    }
  
    @if(show.updateCampaignBudget) {
      <div class="account__card account__card--margin--right account__card--no--animate">
        <update-ongoing-campaign-budget
          class="margin--none"
          (onAbort)="navigateTo('selectContainer')"
          (onSuccess)="loadCampaign(); navigateTo('selectContainer');"
          [campaign]="campaign">
        </update-ongoing-campaign-budget>
      </div>
    }
  
    <div class="campaign-sidebar">
      <dashboard-sidebar [editOngoingCampaign]="true" [campaign]="campaign"></dashboard-sidebar>
    </div>
  </div>
}
